module.exports = __webpack_public_path__ + "img/post4.8321b799.png";